import type { ReactNode } from 'react'
import { Link } from 'react-router'

type NavigationDrawerLogoProps = {
  open: boolean
  logo: ReactNode
  logoVariant?: 'dark' | 'light'
}

export const NavigationDrawerLogo = ({
  open,
  logo,
  logoVariant = 'light',
}: NavigationDrawerLogoProps) => {
  return (
    <Link to="/">
      <div
        css={theme => ({
          padding: open
            ? `${theme.space.Space6} ${theme.space.Space12}`
            : `${theme.space.Space6} ${theme.space.Space3}`,
          background:
            logoVariant === 'light'
              ? theme.semantic.ColorSurfaceDefault
              : theme.semantic.ColorBackgroundFixedDefault,
          color:
            logoVariant === 'light'
              ? theme.semantic.ColorContentDefault
              : theme.semantic.ColorContentOnBackgroundFixedDefault,
          transition: 'padding 200ms',
          textAlign: 'center',
        })}
      >
        {logo}
      </div>
    </Link>
  )
}
